// Client-side session — stores current business context in localStorage

export interface Session {
  businessId: string;
  businessName: string;
  industry: string;
  isAdmin: boolean;
  email?: string;
  phone?: string;
  state?: string;
  subscriptionStatus?: 'none' | 'trialing' | 'active' | 'past_due' | 'canceled';
  planId?: string;
  employeeId?: string;
  employeeName?: string;
  employeeRole?: string;
}

const KEY = 'preuve_session';
const EMP_KEY = 'preuve_employee';

export function getSession(): Session | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Session) : null;
  } catch {
    return null;
  }
}

export function setSession(session: Session): void {
  localStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession(): void {
  localStorage.removeItem(KEY);
  localStorage.removeItem(EMP_KEY);
}

export function setActiveEmployee(id: string, name: string, role: string): void {
  const s = getSession();
  if (s) setSession({ ...s, employeeId: id, employeeName: name, employeeRole: role });
}

export function clearActiveEmployee(): void {
  const s = getSession();
  if (s) {
    const { employeeId: _a, employeeName: _b, employeeRole: _c, ...rest } = s;
    setSession(rest as Session);
  }
}

export function isAdmin(): boolean {
  return getSession()?.isAdmin === true;
}

export function requireSession(): Session {
  const s = getSession();
  if (!s) throw new Error('No active session');
  return s;
}
